






import Vue from 'vue';
const HEADWAY_WIDGET_URL = '//cdn.headwayapp.co/widget.js';

export default Vue.extend({
  data() {
    return {
      config: {
        selector: '.Headwayapp',
        account: 'x82rVJ',
        translations: {
          title: 'お知らせ',
        },
        callbacks: {
          onShowWidget() {
            // TODO close other widget if needed
          },
        },
      },
    };
  },
  mounted() {
    const headwayScript = document.createElement('script');
    headwayScript.async = true;
    headwayScript.setAttribute('src', HEADWAY_WIDGET_URL);
    document.head.appendChild(headwayScript);
    this.toggleWidget();
  },
  beforeDestroy() {
    this.toggleWidget();

    const safeWindow = window as any;
    safeWindow.Headway = undefined;
  },
  methods: {
    toggleWidget() {
      const safeWindow = window as any;
      if (safeWindow && safeWindow.Headway) {
        safeWindow.Headway.init(this.config);
      } else {
        setTimeout(this.toggleWidget, 100);
      }
    },
  },
});
